import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "../form/styles";
import { Divider } from "@material-ui/core";
import Header from "../../../partials/header";
import Loading from "../../loading";
import Form from "../form";
import { getOriginalImage } from "../../../utils/setting";
import Snackbar from "../../snackbar";

export class EditProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {},
    };
  }
  async componentDidMount() {
    let { match } = this.props;
    let { params } = match;
    let { id } = params;
    let result = await this.props.getSingleProduct(id);
    if (result.id) {
      if (!result.variants) result.variants = [];
      if (!result.attributes) result.attributes = [];
      this.setState({ product: result });
    }
  }
  updateProduct = async (images) => {
    let { t } = this.props;
    let product = this.form.getData();
    if (!product.name)
      this.mSnackbar.handleClick(
        t("product_please_fill_in_name_product"),
        "warning"
      );
    else {
      if (images) product.images = images;
      product.date_created = new Date().getTime();
      this.loading.startLoading();
      await this.props.updateProduct(product);
      // this.props.history.push("/productMenu/list");
      this.loading.stopLoading();
    }
  };
  handleSelectImage = async (data) => {
    this.loading.startLoading();
    let checkUpload = await this.props.uploadDispatch.saveStorage({
      files: data.e.target.files[0],
      code: this.props.serviceCode,
      type: "img-product",
    }); // serviceCode lấy từ roleId
    this.loading.stopLoading();
    if (checkUpload.code === 1) {
      let imageGallery = data.imageGallery.map((e) => getOriginalImage(e));
      imageGallery.push(checkUpload.data.previewLink);
      this.updateProduct(imageGallery);
    }
    // else this.mSnackbar.handleClick(t('service_ownerspa_service_album_create_album_unsuccess'),'error')
  };
  deleteImage = async (data) => {
    let imageGallery = data.imageGallery;
    let position = -1;
    imageGallery.forEach((image, index) => {
      if (image === data.imageDelete) position = index;
    });
    if (position !== -1) imageGallery.splice(position, 1);
    this.updateProduct(imageGallery);
  };
  render() {
    const { t, classes } = this.props;
    return (
      <>
        <Header
          session={t("sidebar_service_and_product")}
          title={t("sidebar_product")}
          button={t("product_update")}
          actionButton={this.updateProduct}
          backIcon={true}
          // actionBack={() => this.props.history.push("/productMenu/list")}
          actionBack={() => this.props.history.goBack()}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Divider className={classes.divider} />
        <Loading onRef={(id) => (this.loading = id)} />
        <Form
          data={this.state.product}
          onRef={(id) => (this.form = id)}
          handleSelectImage={this.handleSelectImage}
          deleteImage={this.deleteImage}
        />
      </>
    );
  }
}

const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
});

const mapDispatch = (dispatch) => ({
  updateProduct: dispatch.product.updateProduct,
  getSingleProduct: dispatch.product.getSingleProduct,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(style, { withTheme: 0 })(EditProductMenu)
  )
);
